require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./curated-knowledge-resources.json") })
        }
      }, "path---curated-knowledge-resources");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---curated-knowledge-resources!./.cache/json/curated-knowledge-resources.json
// module id = 1046
// module chunks = 231608221292675